export default {"src":"/_next/static/media/0x579CEa1889991f68aCc35Ff5c3dd0621fF29b0C9.01202ed9.svg","height":180,"width":212,"blurWidth":0,"blurHeight":0};